import { createResourceStore } from "@/lib/resource";
import type { StockBatch } from "./StockBatch";

export interface StockQuantity {
  id: string;
  stock_batch_id: string;
  qty_add: number; // like credit
  qty_remove: number; // like debit
  reason: string;
  event: string;
  date: string; // ISO date string
  created_at?: string;
  updated_at?: string;
  stock_batch: StockBatch;
}

export const useStockQuantity =
  createResourceStore<StockQuantity>("stock-quantities");
